// 概览统计的接口（docs/04 第 8 节）：主数据计数与北京时间当天的用量汇总。金额是基准币种微单位。
import { api } from "./api";

export interface Overview {
  accounts_active: number; channels_active: number;
  today: { message_count: number; delivered_count: number; failed_count: number; sell_base: number; cost_base: number };
}

export const overview = { get: () => api<Overview>("/overview") };
